/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EventHandler = /*#__PURE__*/function () {
  function EventHandler() {
    _classCallCheck(this, EventHandler);
  }

  _createClass(EventHandler, [{
    key: "track",
    value: function track(event) {
      console.warn('Generic track method called on event', event);
    }
  }, {
    key: "pageView",
    value: function pageView(url) {
      console.warn('Generic pageView method called on url', url);
    }
  }]);

  return EventHandler;
}();

exports.default = EventHandler;